import { Paper } from "@mui/material";
import Card from "components/Dashboard/Card";
import { formatMoney } from "./Utils";

export default function PremiumEstimate(props) {
  const t = props.estatedProperty;
  const data = {
    "$2,500 Deductible (Arcana) W/ Water Backup": formatMoney(
      Math.round(t.property_info.estimated_premium_2500_water_backup)
    ),
    "$2,500 Deductible (Arcana) W/O Water Backup": formatMoney(
      Math.round(t.property_info.estimated_premium_2500)
    ),
    "$5,000 Deductible (Arcana) W/ Water Backup": formatMoney(
      Math.round(t.property_info.estimated_premium_5000_water_backup)
    ),
    "$5,000 Deductible (Arcana) W/O Water Backup": formatMoney(
      Math.round(t.property_info.estimated_premium_5000)
    ),
  };
  return (
    <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
      <Card label="Premium Estimate" activeKey="premium_estimate" row={data} />
    </Paper>
  );
}
